import { useMemo } from 'react'

import { i18next } from '@toasttab/buffet-pui-translation-utilities'

export type LocaleOption = {
  locale: string
  label: string
  isoCode: string
}

export const DEFAULT_LOCALE = {
  locale: 'en-US',
  label: 'English (EN)',
  isoCode: 'EN'
}

export const localeOptions: LocaleOption[] = [
  DEFAULT_LOCALE,
  { locale: 'es-US', label: 'Español (ES)', isoCode: 'ES' },
  { locale: 'zh-Hans', label: '简体中文 (ZH)', isoCode: 'ZH' },
  { locale: 'fr-CA', label: 'Français (FR)', isoCode: 'FR' }
]

export const OO_SELECTED_LANGUAGE = 'TOAST-OO-selectedLanguage'

export function useSelectedLocale() {
  const selectedLocale = useMemo(() => {
    const locale = i18next.language
    if (locale) {
      const found = localeOptions.find((option) => option.locale === locale)
      return found ? found : DEFAULT_LOCALE
    }
    return undefined
  }, [])

  return { selectedLocale }
}
